import { useSelector } from 'react-redux';
import cn from 'classnames';
import { isMobileLayout } from 'components/Shared/responsive';
import { IconArrow } from 'components/Shared/Icon';
import styles from './link.scss';
import { Reducer, useEffect, useReducer } from 'react';
import { getGetImageUrl } from 'services/ApiKnowledgebaseService';

interface LinkProps {
  url: string;
  title: string;
  body: string;
  image: string;
  isBlog: string;
}

interface InternalState {
  image: string;
}

const initialItemState: InternalState = {
  image: ''
};

type InternalAction = { type: 'image'; value: string };

const internalReducer: Reducer<InternalState, InternalAction> = (state, action) => {
  switch (action.type) {
    case 'image': {
      return { ...state, image: action.value };
    }
    default:
      return state;
  }
};

const BaseLink = ({ url, title, body, image, isBlog }: LinkProps) => {
  const [state, dispatch] = useReducer(internalReducer, initialItemState);
  const mobile = useSelector(isMobileLayout);

  useEffect(() => {
    void getGetImageUrl(image).then(response => {
      dispatch({ type: 'image', value: response.url });
    });
  }, [image]);

  return (
    <a
      href={url}
      className={cn(styles.link, {
        [styles.blog]: isBlog === '1'
      })}
    >
      <div className={styles.img} style={{ backgroundImage: `url(${state.image})` }} />
      <div className={styles.divider} />
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        <div className={styles.text}>{body}</div>
      </div>
      <IconArrow className={styles.arrow} thickness={mobile ? 'thick' : 'thin'} />
    </a>
  );
};

export const Link = (props: LinkProps) => <BaseLink {...props} />;
